import { Form } from "@redriver/cinnamon-mui";
import { disciplinesLookup } from "modules/lookups";

const DisciplineCheckboxGroup = (props) => (
  <Form.CheckboxGroup lookup={disciplinesLookup} {...props} />
);

export default DisciplineCheckboxGroup;
